@if (isInit) {
    <div class="q-container">
        <!-- Normal questions -->
        @if (!question.option?.subQuestionCode) {
            <div>
                @for (
                    questionInstancesInput of questionInstancesInputEntries;
                    track questionInstancesInput;
                    let qIndex = $index
                ) {
                    <div class="flex flex-column">
                        @if (
                            translateService.keyExists('question.' + question.questionCode + '.leg0') &&
                            !(question.isDynamic && qIndex !== 0) &&
                            (question.questionCode === 'q008' || question.questionCode === 'q008a')
                        ) {
                            <p class="q-text legend">
                                {{ 'question.' + question.questionCode + '.leg0' | translate }}
                            </p>
                        }
                        @if (!questionInstancesInput.hidden) {
                            <div class="flex flex-row col-11 p-0 m-1">
                                @if (question.value.value1Type) {
                                    <div class="label-question-container">
                                        @if (
                                            translateService.keyExists('question.' + question.questionCode + '.leg0') &&
                                            !(question.isDynamic && qIndex !== 0) &&
                                            question.questionCode !== 'q008' &&
                                            question.questionCode !== 'q008a'
                                        ) {
                                            <p class="q-text legend">
                                                {{ 'question.' + question.questionCode + '.leg0' | translate }}
                                            </p>
                                        }
                                        <div class="q-heading">
                                            @if (
                                                translateService.keyExists(
                                                    'question.' + question.questionCode + '.title1'
                                                ) &&
                                                !(question.isDynamic && qIndex !== 0) &&
                                                !(
                                                    parentQuestionInstance !== undefined &&
                                                    parentQuestionInstance.instanceId === undefined
                                                )
                                            ) {
                                                <label
                                                    class="q-text q-title"
                                                    [attr.for]="titleFieldId(questionInstancesInput, qIndex)">
                                                    {{ 'question.' + question.questionCode + '.title1' | translate }}
                                                </label>
                                            }
                                            <!-- nosemgrep: java.lang.security.audit.xss.jsf.autoescape-disabled.autoescape-disabled -->
                                            @if (
                                                translateService.keyExists(
                                                    'question.' + question.questionCode + '.infoType'
                                                ) && !(question.isDynamic && qIndex !== 0)
                                            ) {
                                                <span
                                                    class="material-symbols-outlined icon-md cursor-help"
                                                    [pTooltip]="tooltipContent"
                                                    [escape]="false">
                                                    info
                                                </span>
                                            }
                                        </div>
                                        @if (
                                            translateService.keyExists('question.' + question.questionCode + '.leg1') &&
                                            !(question.isDynamic && qIndex !== 0)
                                        ) {
                                            <p class="q-text legend">
                                                {{ 'question.' + question.questionCode + '.leg1' | translate }}
                                            </p>
                                        }
                                    </div>
                                }
                                @if (
                                    translateService.keyExists('question.' + question.questionCode + '.title2') ||
                                    translateService.keyExists('question.' + question.questionCode + '.leg2')
                                ) {
                                    <div class="label-question-container">
                                        @if (
                                            translateService.keyExists('question.' + question.questionCode + '.leg0') &&
                                            !(question.isDynamic && qIndex !== 0) &&
                                            question.questionCode !== 'q008' &&
                                            question.questionCode !== 'q008a'
                                        ) {
                                            <!-- Invisible copy of the legend beside, so both titles line up. -->
                                            <p class="q-text legend legend--spacer" aria-hidden="true">
                                                {{ 'question.' + question.questionCode + '.leg0' | translate }}
                                            </p>
                                        }
                                        @if (
                                            translateService.keyExists(
                                                'question.' + question.questionCode + '.title2'
                                            ) && !(question.isDynamic && qIndex !== 0)
                                        ) {
                                            <p class="q-text q-title">
                                                {{ 'question.' + question.questionCode + '.title2' | translate }}
                                            </p>
                                        }
                                        @if (
                                            translateService.keyExists('question.' + question.questionCode + '.leg2') &&
                                            !(question.isDynamic && qIndex !== 0)
                                        ) {
                                            <p class="q-text legend">
                                                {{ 'question.' + question.questionCode + '.leg2' | translate }}
                                            </p>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        <app-question-instance
                            [hidden]="questionInstancesInput.hidden"
                            [question]="question"
                            [id]="questionInstancesInput.instance.questionCode + '_' + qIndex"
                            [questionInstancesInput]="questionInstancesInput"
                            [domain1Map]="domain1Map"
                            (inputEscape)="onInputEscape($event)"
                            (enumChange)="onEnumChange($event)"
                            (deleteEntry)="deleteEntry($event)"
                            [domain1]="domain1"
                            [domainPerCode]="domainPerCode"
                            [index]="qIndex"
                            [locale]="locale"
                            [orgId]="orgId"
                            [isLocked]="isLocked"
                            [readOnly]="readOnly"
                            [disabled]="
                                parentQuestionInstance !== undefined && parentQuestionInstance.instanceId === undefined
                            "
                            (focusNextInputEvent)="focusNextInput($event)"
                            [currentEntityFte]="currentEntityFte"></app-question-instance>
                    </div>
                }
            </div>
        } @else {
            <div class="label-question-container">
                <div class="q-heading">
                    @if (translateService.keyExists('question.' + question.questionCode + '.title1')) {
                        <p class="q-text q-title">
                            {{ 'question.' + question.questionCode + '.title1' | translate }}
                        </p>
                    }
                    <!-- nosemgrep: java.lang.security.audit.xss.jsf.autoescape-disabled.autoescape-disabled -->
                    @if (translateService.keyExists('question.' + question.questionCode + '.infoType')) {
                        <span
                            class="material-symbols-outlined icon-md cursor-help"
                            [pTooltip]="tooltipContent"
                            [escape]="false">
                            info
                        </span>
                    }
                </div>
                @if (translateService.keyExists('question.' + question.questionCode + '.leg1')) {
                    <p class="q-text legend">
                        {{ 'question.' + question.questionCode + '.leg1' | translate }}
                    </p>
                }
            </div>
            <div class="mt-3">
                <p-accordion class="entry-list" [value]="activeIndex" [dt]="entryCardTokens">
                    @for (
                        questionInstancesInput of nonHiddenEntries;
                        track questionInstancesInput;
                        let qIndex = $index
                    ) {
                        <p-accordion-panel class="entry-card" [value]="qIndex">
                            <p-accordion-header class="entry-card__head">
                                <div class="entry-head">
                                    <span class="material-symbols-outlined icon-md entry-head__icon" aria-hidden="true"
                                        >directions_car</span
                                    >
                                    <div class="entry-head__main">
                                        <span
                                            class="entry-head__type"
                                            [class.entry-head__type--new]="
                                                !questionInstancesInput.value1ControlInitValue
                                            ">
                                            {{
                                                questionInstancesInput.value1ControlInitValue
                                                    ? ('enum.' +
                                                          domain1Map.get(questionInstancesInput.value1Control.value)
                                                              ?.domain +
                                                          '.' +
                                                          questionInstancesInput.value1ControlInitValue | translate)
                                                    : ('enum.commuteCompany.NouveauVehicule' | translate)
                                            }}
                                        </span>
                                        @if (questionInstancesInput.value2ControlInitValue) {
                                            <span class="entry-head__count">
                                                {{ '× ' + questionInstancesInput.value2ControlInitValue }}
                                            </span>
                                        }
                                    </div>
                                    @if (
                                        questionInstancesInput.value3ControlInitValue &&
                                        questionInstancesInput.unitControlInitValue
                                    ) {
                                        <span class="entry-head__quantity">
                                            {{
                                                questionInstancesInput.value3ControlInitValue +
                                                    ' ' +
                                                    ('unit.' + questionInstancesInput.unitControlInitValue | translate)
                                            }}
                                        </span>
                                    }
                                    @if (
                                        question.isDynamic &&
                                        questionInstancesInput.instanceId &&
                                        !questionInstancesInput.isDisabledLike &&
                                        !readOnly
                                    ) {
                                        <p-button
                                            icon="ms ms-delete"
                                            severity="secondary"
                                            [text]="true"
                                            [rounded]="true"
                                            size="small"
                                            [ariaLabel]="'advancedMeasure.form.delete' | translate"
                                            (onClick)="deleteEntry(questionInstancesInput)" />
                                    }
                                </div>
                            </p-accordion-header>
                            <p-accordion-content>
                                <app-question-instance
                                    [hidden]="questionInstancesInput.hidden"
                                    [question]="question"
                                    [id]="questionInstancesInput.instance.questionCode + '_' + qIndex"
                                    [questionInstancesInput]="questionInstancesInput"
                                    [domain1Map]="domain1Map"
                                    (inputEscape)="onInputEscape($event)"
                                    (enumChange)="onEnumChange($event)"
                                    [domain1]="domain1"
                                    [domainPerCode]="domainPerCode"
                                    [index]="qIndex"
                                    [locale]="locale"
                                    [orgId]="orgId"
                                    [isLocked]="isLocked"
                                    [readOnly]="readOnly"
                                    [disabled]="false"
                                    (focusNextInputEvent)="focusNextInput($event)"></app-question-instance>
                                @if (subQuestion) {
                                    <app-question
                                        #subQuestionComponent
                                        [question]="subQuestion"
                                        [domainPerCode]="domainPerCode"
                                        [orgId]="orgId"
                                        [questionnaireId]="questionnaireId"
                                        [locale]="locale"
                                        [parentQuestionInstance]="questionInstancesInput">
                                    </app-question>
                                }
                            </p-accordion-content>
                        </p-accordion-panel>
                    }
                </p-accordion>
            </div>
        }
        <div class="footer-question">
            @if (question.isDynamic && domain1.length !== 0 && hasNotEmptyInput() && !readOnly) {
                <!-- Locked scan: insertEntry() also guards on isLocked. -->
                @if (isAccordionList) {
                    <button type="button" class="add-entry" [disabled]="isLocked" (click)="insertEntry()">
                        <span class="material-symbols-outlined icon-md" aria-hidden="true">add_circle</span>
                        {{ 'question.addVehicle' | translate }}
                    </button>
                } @else {
                    <p-button
                        icon="ms ms-add"
                        severity="secondary"
                        [text]="true"
                        [label]="'question.addEntry' | translate"
                        [disabled]="isLocked"
                        (onClick)="insertEntry()" />
                }
            }
        </div>
    </div>
}
